/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminFacilityAsset,
  AdminV1OrganizationsPaymentsFacilityAssetsListParams,
  PaginatedAdminFacilityAssetList,
  PatchedAdminFacilityAsset
} from '.././model';

import adminV1OrganizationsPaymentsFacilityAssetsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsFacilityAssetsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsFacilityAssetsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsFacilityAssetsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsFacilityAssetsPartialUpdateMutator from '../../shared/services/axios-client';
import adminFacilityAssetDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsFacilityAssetsList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsFacilityAssetsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsFacilityAssetsListMutator<PaginatedAdminFacilityAssetList>>,) => {
      return adminV1OrganizationsPaymentsFacilityAssetsListMutator<PaginatedAdminFacilityAssetList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsFacilityAssetsCreate = (
    organizationId: number,
    adminFacilityAsset: NonReadonly<AdminFacilityAsset>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsFacilityAssetsCreateMutator<AdminFacilityAsset>>,) => {
      return adminV1OrganizationsPaymentsFacilityAssetsCreateMutator<AdminFacilityAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminFacilityAsset
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsFacilityAssetsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsFacilityAssetsRetrieveMutator<AdminFacilityAsset>>,) => {
      return adminV1OrganizationsPaymentsFacilityAssetsRetrieveMutator<AdminFacilityAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsFacilityAssetsUpdate = (
    organizationId: number,
    id: string,
    adminFacilityAsset: NonReadonly<AdminFacilityAsset>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsFacilityAssetsUpdateMutator<AdminFacilityAsset>>,) => {
      return adminV1OrganizationsPaymentsFacilityAssetsUpdateMutator<AdminFacilityAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminFacilityAsset
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsFacilityAssetsPartialUpdate = (
    organizationId: number,
    id: string,
    patchedAdminFacilityAsset: NonReadonly<PatchedAdminFacilityAsset>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsFacilityAssetsPartialUpdateMutator<AdminFacilityAsset>>,) => {
      return adminV1OrganizationsPaymentsFacilityAssetsPartialUpdateMutator<AdminFacilityAsset>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminFacilityAsset
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Soft deletes a facility asset
 */
export const adminFacilityAssetDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminFacilityAssetDestroyMutator<void>>,) => {
      return adminFacilityAssetDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/facility-assets/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsFacilityAssetsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsFacilityAssetsList>>>
export type AdminV1OrganizationsPaymentsFacilityAssetsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsFacilityAssetsCreate>>>
export type AdminV1OrganizationsPaymentsFacilityAssetsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsFacilityAssetsRetrieve>>>
export type AdminV1OrganizationsPaymentsFacilityAssetsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsFacilityAssetsUpdate>>>
export type AdminV1OrganizationsPaymentsFacilityAssetsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsFacilityAssetsPartialUpdate>>>
export type AdminFacilityAssetDestroyResult = NonNullable<Awaited<ReturnType<typeof adminFacilityAssetDestroy>>>
